const itineraries = {
   DelhiAgraJaipur: [
        {
            day: "Day 01",
            title: "Arrival in Delhi – Agra",
            content:
                "Upon arrival at Delhi Airport, meet our representative who will assist you with your transfer to Agra. After checking in at the hotel and taking some rest, visit the iconic Taj Mahal – a symbol of eternal love and one of the Seven Wonders of the World. Later, explore the historic Agra Fort, a UNESCO World Heritage site made of red sandstone located on the banks of the Yamuna River. Overnight stay at the hotel in Agra."
        },
        {
            day: "Day 02",
            title: "Agra – Fatehpur Sikri – Jaipur",
            content:
                "After breakfast, check out from the hotel and proceed to Jaipur. En route, stop at Fatehpur Sikri – the deserted red sandstone city built by Emperor Akbar, known for its grand architecture and historical significance. Continue your journey to Jaipur. On arrival, check in to the hotel and relax. Overnight stay at the hotel in Jaipur."
        },
        {
            day: "Day 03",
            title: "Jaipur Sightseeing",
            content:
                "After an early breakfast, enjoy a full day of sightseeing in the Pink City of Jaipur. Visit Amber Fort, located 11 km from the city, an impressive structure built of red sandstone and white marble. Explore the rich cultural heritage, including City Palace, Jantar Mantar, and more. Experience the charm of Jaipur's architectural marvels. Overnight stay at the hotel in Jaipur."
        },
        {
            day: "Day 04",
            title: "Jaipur – Cultural Tour & Shopping",
            content:
                "After breakfast, visit the majestic Amer Fort and enjoy an elephant ride to reach the top. Explore Chandra Mahal, Mubarak Mahal, Hawa Mahal (Palace of Winds), and Nahargarh Fort. In the evening, enjoy leisure time for shopping in the vibrant local markets of Jaipur. Overnight stay at the hotel in Jaipur."
        },
        {
            day: "Day 05",
            title: "Jaipur – Delhi Departure",
            content:
                "Post breakfast, check out from the hotel and drive back to Delhi. You will be dropped off at Delhi Airport / Railway Station / Bus Stand for your onward journey, marking the end of the tour with beautiful memories."
        }
    ],

   Goa: [
  {
    day: "Day 01",
    title: "Arrival at Goa",
    content:
      "Welcome to Goa! On arrival at the airport or railway station, meet our representative who will assist with your transfer to the hotel. Check-in and relax. Enjoy the day at leisure—explore nearby attractions, taste Goan delicacies, or simply unwind. Return to the hotel for a cozy overnight stay."
  },
  {
    day: "Day 02",
    title: "North Goa Sightseeing",
    content:
      "After breakfast, begin your North Goa sightseeing tour. Visit the iconic Aguada Fort, followed by Calangute Beach – the largest beach in North Goa. Continue to Baga Beach, known for its nightlife and food joints, and finally explore Anjuna Beach, famous for its party vibe and flea markets. Return to the hotel for an overnight stay."
  },
  {
    day: "Day 03",
    title: "South Goa Sightseeing",
    content:
      "Start your day with breakfast and head out to explore South Goa. Visit Shri Shantadurga and Shri Mangesh Temples, followed by the historic churches – Basilica of Bom Jesus and Se Cathedral. Enjoy the scenic view from Dona Paula Bay overlooking Mormugao Harbour. End the day with a serene Mandovi River cruise featuring Goan folk music and dance. Return to the hotel for the night."
  },
  {
    day: "Day 04",
    title: "Water Sports & Leisure",
    content:
      "Have breakfast and proceed to Candolim Beach for thrilling water sports like Jet Ski, Paragliding, Banana Ride, Bumper Ride, and Speed Boat Ride. After the adventure, enjoy leisure time—opt for crocodile sightseeing, quad biking, birdwatching, or shopping near Candolim. Overnight stay at the hotel."
  },
  {
    day: "Day 05",
    title: "Grand Island Tour",
    content:
      "Post breakfast, proceed to Coco Beach jetty for a boat ride to Grand Island. Watch playful dolphins en route. Enjoy snorkeling and swimming in the clear waters surrounded by vibrant coral reefs. Relish a delicious barbecue lunch on the island before returning to your hotel. Evening at leisure and overnight stay."
  },
  {
    day: "Day 06",
    title: "Dudhsagar Waterfalls & Spice Plantations",
    content:
      "After breakfast, embark on an excursion to Dudhsagar Waterfalls – one of India's tallest and most scenic waterfalls. Enjoy nature, birdwatching, or short treks. Later, visit aromatic Spice Plantations and learn about traditional farming. Return to the hotel and rest for the night."
  },
  {
    day: "Day 07",
    title: "Departure from Goa",
    content:
      "Enjoy your final breakfast in Goa. Check out from the hotel and proceed to the airport or railway station for your journey back home, carrying unforgettable memories of your 6 Nights / 7 Days trip."
  }
    ],

   JaipurJodhpurJaisalmerBikaner: [
  {
    day: "Day 01",
    title: "Arrival in Jaipur",
    content:
      "On arrival at Jaipur, meet and greet our representative and transfer to your hotel. Proceed for an excursion to Amber Fort, including the glittering Sheesh Mahal (Hall of Mirrors), Jai Mahal, and the Temple of Kali. Enjoy an elephant ride up to the fort. Later, visit the Maharaja’s City Palace, Jantar Mantar (the observatory), Albert Hall Museum, Ram Niwas Gardens, and the iconic Hawa Mahal. Overnight stay at the hotel in Jaipur."
  },
  {
    day: "Day 02",
    title: "Jaipur to Jodhpur",
    content:
      "After breakfast, drive to Jodhpur. Upon arrival, check into the hotel and relax. Later, explore Jodhpur’s key attractions – visit the grand Mehrangarh Fort, offering stunning views of the city, and Jaswant Thada, the royal cenotaphs built in memory of Maharaja Jaswant Singh. Overnight stay at the hotel in Jodhpur."
  },
  {
    day: "Day 03",
    title: "Jodhpur to Jaisalmer (Thar Desert Experience)",
    content:
      "After breakfast, drive to Jaisalmer. On arrival, transfer to a desert camp near a village outside Jaisalmer. Enjoy a camel safari into the sand dunes of Sam. Witness a breathtaking sunset over the Thar Desert and spend the evening enjoying traditional Rajasthani dance and cultural activities under the stars. Overnight stay in tented desert accommodation."
  },
  {
    day: "Day 04",
    title: "Jaisalmer City Tour",
    content:
      "After breakfast, transfer to Jaisalmer for sightseeing. Visit the historic Golden Fort (Sonar Quila), a UNESCO World Heritage Site. Explore Gadisar Lake and take a walking tour of the intricately carved Havelis including Patwon Ki Haveli and Jain Temples. Overnight stay at the hotel in Jaisalmer."
  },
  {
    day: "Day 05",
    title: "Jaisalmer to Bikaner",
    content:
      "After breakfast, drive to Bikaner. On arrival, check into the hotel and later visit the magnificent Junagarh Fort made of red sandstone, known for its exquisite pietra dura and painted interiors. Visit the Lalgarh Palace and Museum, known for its lattice and filigree work. End the day with a visit to Asia’s largest Camel Breeding Farm to see various camel breeds. Overnight stay at the hotel in Bikaner."
  },
  {
    day: "Day 06",
    title: "Bikaner to Jaipur",
    content:
      "After breakfast, check out and drive back to Jaipur. On arrival, check into the hotel. In the evening, enjoy an optional dinner at Chokhi Dhani, an ethnic village-themed resort that offers traditional Rajasthani cuisine, folk dances, puppet shows, and more. Overnight stay at the hotel in Jaipur."
  },
  {
    day: "Day 07",
    title: "Departure from Jaipur",
    content:
      "After breakfast, check out from the hotel and proceed to Jaipur Railway Station or Airport for your onward journey, taking back beautiful memories of your Rajasthan trip."
  }
   ],

   JaipurAjmerPushkarJodhpurUdaipur: [
  {
    day: "Day 01",
    title: "Arrival in Jaipur",
    content:
      "On arrival in the charming Pink City of India, check in at your hotel. In the evening, enjoy an optional dinner at Chokhi Dhani, an ethnic village resort that offers a glimpse of traditional Rajasthani life. Enjoy folk dances, puppet shows, and various cultural activities. Overnight stay at the hotel in Jaipur."
  },
  {
    day: "Day 02",
    title: "Jaipur Sightseeing",
    content:
      "After breakfast, enjoy a full-day sightseeing tour of Jaipur. Visit Jaigarh Fort, City Palace, Jantar Mantar (the observatory), Hawa Mahal (Palace of Winds), Birla Temple, and the old capital Amber Fort. Enjoy an elephant ride to the entrance of Amber Fort, which features a unique blend of Mughal and Rajput architecture. In the evening, take a rickshaw tour through the vibrant streets and bazaars of Jaipur. Overnight stay at the hotel."
  },
  {
    day: "Day 03",
    title: "Jaipur to Ajmer & Pushkar",
    content:
      "After breakfast, check out and drive towards Pushkar. En route, visit Ajmer where you’ll explore Ajmer-e-Sharief Dargah, Adhai-Din-Ka Jhonpara, and Ana Sagar Lake. Continue your journey to Pushkar (14 km from Ajmer), visit the sacred Pushkar Lake, numerous ghats, and over 400 temples, including the famous Brahma Temple—the only one of its kind in India. Explore the colorful local bazaar. Overnight stay in Pushkar."
  },
  {
    day: "Day 04",
    title: "Pushkar to Jodhpur",
    content:
      "After breakfast, check out and drive to Jodhpur. On arrival, check in to the hotel. In the afternoon, visit Mehrangarh Fort situated on a low sandstone hill. Inside the fort, explore Moti Mahal and Phool Mahal. Visit Jaswant Thada, a white marble memorial, and the Umaid Bhawan Palace and Museum, known for its art-deco architecture. Overnight stay in Jodhpur."
  },
  {
    day: "Day 05",
    title: "Jodhpur to Udaipur",
    content:
      "After breakfast, check out and drive to Udaipur, known as the City of Lakes. On arrival, check in to the hotel and enjoy the rest of the day at leisure. Overnight stay in Udaipur."
  },
  {
    day: "Day 06",
    title: "Udaipur Sightseeing",
    content:
      "After breakfast, set out for a city tour of Udaipur. Visit the majestic City Palace and its museum, Jagdish Temple, Sahelion Ki Bari (Garden of the Maidens), Bhartiya Lok Kala Mandir (Folk Art Museum), and Pratap Memorial. Enjoy the serene beauty and royal architecture of Udaipur. Overnight stay at the hotel."
  },
  {
    day: "Day 07",
    title: "Departure from Udaipur",
    content:
      "After breakfast, check out from the hotel and proceed to the domestic airport or railway station for your onward journey. Depart with sweet memories, souvenirs, and new friendships from your Rajasthan tour."
  }
   ],

   Kerala: [
  {
    day: "Day 01",
    title: "Arrival in Guruvayur",
    content:
      "On arrival at Trichur Railway Station or Cochin Airport, our representatives will welcome you and transfer you to the hotel in Guruvayur. Check-in and relax. In the evening, participate in darshan at the sacred Sri Krishna Temple. Overnight stay at the hotel."
  },
  {
    day: "Day 02",
    title: "Guruvayur to Munnar",
    content:
      "After breakfast, proceed to Munnar (approx. 230 km / 4.5 hrs). On arrival, check in to your hotel and relax. Munnar is one of the most popular hill stations in Southern India, famous for its lush green tea estates. Enjoy a peaceful evening and overnight stay in Munnar."
  },
  {
    day: "Day 03",
    title: "Munnar Sightseeing",
    content:
      "After breakfast, enjoy a sightseeing tour of Munnar. Visit sprawling tea estates, Mettupatty Dam for a boat ride, Kundala Lake, and Echo Point. Experience the natural beauty and tranquil environment of the hill station. Overnight stay at your hotel in Munnar."
  },
  {
    day: "Day 04",
    title: "Munnar to Alleppey (Houseboat)",
    content:
      "After breakfast, check out from your Munnar hotel and head to Alleppey (approx. 180 km / 5 hrs), often called the 'Venice of the East.' On arrival, board a traditional Kerala houseboat for a cruise through the scenic backwaters. Glide past lush paddy fields, charming villages, and serene lagoons. Enjoy local delicacies on board and spend the night on the houseboat."
  },
  {
    day: "Day 05",
    title: "Alleppey to Kovalam",
    content:
      "After breakfast, disembark from the houseboat and drive to Kovalam (approx. 180 km / 3.5 hrs), Kerala’s renowned international beach destination. On arrival, check into your resort/hotel. Spend the day relaxing on the beach, swimming, or enjoying water sports. Savor seafood or traditional Kerala cuisine. Overnight stay in Kovalam."
  },
  {
    day: "Day 06",
    title: "Kovalam to Cochin",
    content:
      "After breakfast, proceed to Cochin (approx. 90 km / 1.5 hrs). On arrival, enjoy a sightseeing tour including Dutch Palace, Jewish Synagogue, Chinese Fishing Nets, and Santa Cruz Basilica. In the evening, take a boat ride on the Arabian Sea aboard the Sagar Rani. Overnight stay at your hotel in Cochin."
  },
  {
    day: "Day 07",
    title: "Departure from Cochin",
    content:
      "After breakfast, check out from the hotel and transfer to Cochin Airport or Railway Station for your onward journey, carrying beautiful memories from your Kerala honeymoon."
  }
   ],

    LehLadakh: [
  {
    day: "Day 01",
    title: "Arrival in Leh",
    content:
      "After arrival at Leh Airport, transfer to your hotel for check-in. Spend the day at leisure for acclimatization to the high altitude climate. Explore Leh town at your own pace. Overnight stay at the hotel in Leh.",
    meals: "Breakfast"
  },
  {
    day: "Day 02",
    title: "Leh – Sangam – Hall of Fame – Leh",
    content:
      "After breakfast, enjoy a half-day excursion to the Hall of Fame, Gurudwara Pathar Sahib, Magnetic Hill, and Sangam View where the Indus and Zanskar rivers meet. Return to hotel in the afternoon. In the evening, enjoy the sunset at Shanti Stupa. Overnight at the hotel in Leh.",
    meals: "Breakfast and Dinner"
  },
  {
    day: "Day 03",
    title: "Leh – Pangong Lake",
    content:
      "After breakfast, check out from the hotel and drive to Pangong Lake via Changla Pass (17,500 ft), passing through Durbuk and Tangtse villages. Witness the spectacular lake that changes colors 4-5 times a day. Overnight stay at the camp by Pangong Lake.",
    meals: "Breakfast"
  },
  {
    day: "Day 04",
    title: "Pangong Lake – Leh",
    content:
      "After breakfast, check out from the camp and drive back to Leh. En route, visit Hemis, Shey, and Thiksey monasteries. Evening at leisure for your own activities. Overnight stay at the hotel in Leh.",
    meals: "Breakfast"
  },
  {
    day: "Day 05",
    title: "Leh – Khardung La Top – Nubra Valley",
    content:
      "Drive to Nubra Valley via Khardung La Top, the highest motorable road in the world at 18,380 ft. Nubra Valley, also known as Ldorma or the Valley of Flowers, is located between the Karakoram and Ladakh ranges. Arrive at Hunder and check in to your hotel or camp. Visit Diskit Village and enjoy a camel ride on the sand dunes. Dinner and overnight stay at hotel/camp.",
    meals: "Breakfast"
  },
  {
    day: "Day 06",
    title: "Nubra Valley – Leh",
    content:
      "After breakfast, drive back to Leh via the same Khardung La route. Check in at your hotel on arrival. Spend the evening exploring the Leh market for shopping. Overnight stay at the hotel.",
    meals: "Breakfast"
  },
  {
    day: "Day 07",
    title: "Departure from Leh",
    content:
      "After breakfast, check out from the hotel and transfer to Leh Airport for your onward journey, concluding your memorable Ladakh honeymoon tour.",
    meals: "Breakfast"
  }
   ],

    Kashmir: [
  {
    day: "Day 01",
    title: "Srinagar Arrival",
    content:
      "Arrive at Srinagar, pick up and transfer to Houseboat or Hotel. Rest of the day at leisure or visit Nehru Garden. Overnight at Houseboat/Hotel.",
    meals: "Breakfast"
  },
  {
    day: "Day 02",
    title: "Srinagar Local Sightseeing",
    content:
      "After breakfast, visit the world-famous Mughal Gardens: Nishat Bagh (Garden of Pleasure), Shalimar Bagh (Abode of Love), and Chasme Shahi Garden. In the afternoon, enjoy a Shikara ride on Dal Lake to experience the beauty of Srinagar, often compared to Venice. Overnight at Houseboat/Hotel.",
    meals: "Breakfast and Dinner"
  },
  {
    day: "Day 03",
    title: "Srinagar to Gulmarg",
    content:
      "After breakfast, drive to Gulmarg, a beautiful summer resort known for the highest golf course in the world and winter skiing. Enjoy a Gondola (cable car) ride to Khalinmarg. Return to hotel in Gulmarg for overnight stay.",
    meals: "Breakfast"
  },
  {
    day: "Day 04",
    title: "Gulmarg Leisure",
    content:
      "Free day in Gulmarg to relax or try skiing. Overnight stay in Gulmarg.",
    meals: "Breakfast"
  },
  {
    day: "Day 05",
    title: "Gulmarg to Pahalgam",
    content:
      "After breakfast, drive to Pahalgam (2440 Mtrs - Vale of Kashmir). En route, visit saffron fields and Avantipur ruins (an 1100-year-old temple). Reach Pahalgam by lunchtime and enjoy the natural charm of the valley. Overnight at hotel in Pahalgam.",
    meals: "Breakfast"
  },
  {
    day: "Day 06",
    title: "Pahalgam Leisure",
    content:
      "Free day to enjoy the scenic beauty of Pahalgam. Overnight at hotel in Pahalgam.",
    meals: "Breakfast"
  },
  {
    day: "Day 07",
    title: "Pahalgam to Srinagar",
    content:
      "After breakfast, drive back to Srinagar. Rest of the day free for relaxation or shopping. Overnight at Houseboat/Hotel.",
    meals: "Breakfast"
  },
  {
    day: "Day 08",
    title: "Srinagar – Sonmarg – Srinagar",
    content:
      "Full day excursion to Sonmarg (Meadow of Gold at 2690 Mtrs). En route stop at beautiful spots. Optional horse ride to Thajiwas Glacier, where snow remains year-round. Return to Srinagar for overnight stay.",
    meals: "Breakfast"
  },
  {
    day: "Day 09",
    title: "Departure from Srinagar",
    content:
      "After breakfast, transfer to Airport or Bus Station for onward journey, concluding your Kashmir honeymoon tour.",
    meals: "Breakfast"
  }
   ],

    Nainital: [
  {
    day: "Day 01",
    title: "Delhi to Nainital",
    content:
      "Arrival in Delhi and proceed to Nainital, a beautiful hill station in Uttarakhand. Upon arrival, check in to the hotel. Evening free for leisure. Overnight stay in Nainital.",
    meals: "Breakfast"
  },
  {
    day: "Day 02",
    title: "Nainital - Bhimtal - Sattal - Nainital",
    content:
      "After breakfast, enjoy a full day excursion covering Bhimtal, Sattal, and Naukuchiatal. Enjoy boating and scenic views. Return to Nainital by evening. Overnight stay at hotel.",
    meals: "Breakfast"
  },
  {
    day: "Day 03",
    title: "Explore Nainital – The Paradise City",
    content:
      "Explore the local attractions of Nainital such as Naini Lake, Naina Devi Temple, Snow View Point, and Mall Road. Enjoy shopping and local delicacies. Overnight stay in Nainital.",
    meals: "Breakfast"
  },
  {
    day: "Day 04",
    title: "Nainital Leisure Day",
    content:
      "Free day to relax or explore more beautiful spots like Tiffin Top, Eco Cave Garden, or take a ropeway ride. Enjoy the serene beauty of the hills. Overnight stay in Nainital.",
    meals: "Breakfast"
  },
  {
    day: "Day 05",
    title: "Nainital to Kausani – Honeymooners’ Paradise",
    content:
      "After breakfast, drive to Kausani, known for its scenic vistas and peaceful atmosphere. En route, enjoy Almora sightseeing. On arrival, check into hotel and enjoy sunset views. Overnight stay in Kausani.",
    meals: "Breakfast"
  },
  {
    day: "Day 06",
    title: "Explore Kausani",
    content:
      "After breakfast, visit Anashakti Ashram, Tea Gardens, and Baijnath Temple. Enjoy panoramic views of Himalayan peaks. Evening at leisure. Overnight stay in Kausani.",
    meals: "Breakfast"
  },
  {
    day: "Day 07",
    title: "Kausani to Corbett National Park",
    content:
      "After breakfast, drive to Jim Corbett National Park. On arrival, check-in to your wildlife resort. Evening at leisure in the natural surroundings. Overnight stay in Corbett.",
    meals: "Breakfast"
  },
  {
    day: "Day 08",
    title: "Corbett Sightseeing",
    content:
      "Early morning jungle safari (optional, at additional cost). Later, visit Corbett Museum, Garjia Temple and Corbett Falls. Return to resort and relax. Overnight stay in Corbett.",
    meals: "Breakfast"
  },
  {
    day: "Day 09",
    title: "Corbett to Delhi – Departure",
    content:
      "After breakfast, check-out and drive back to Delhi for your onward journey with sweet honeymoon memories.",
    meals: "Breakfast"
  }
   ],

    Udaipur : [
  {
    day: "Day 01",
    title: "Arrival in Udaipur and Local Sightseeing",
    content:
      "On arrival at Udaipur railway station or airport, our driver will pick you up and transfer you to your hotel. After check-in and a short rest, begin your sightseeing tour of Udaipur covering Saheliyon Ki Bari, Sukhadia Circle, Fateh Sagar Lake, Aquarium, Maharana Pratap Smarak, Rajasthan Museum, City Palace, and more.",
    meals: "Breakfast"
  },
  {
    day: "Day 02",
    title: "Day Trip to Kumbhalgarh and Ranakpur",
    content:
      "After breakfast, proceed for a full-day excursion to Kumbhalgarh Fort and the beautiful Ranakpur Jain Temples. Return to Udaipur in the evening. Overnight stay at the hotel in Udaipur.",
    meals: "Breakfast"
  },
  {
    day: "Day 03",
    title: "Day Trip to Chittorgarh",
    content:
      "Post breakfast, enjoy a day trip to Chittorgarh Fort, one of the largest forts in India. Explore its historic sites, towers, temples, and palaces. Return to Udaipur by evening. Overnight stay in Udaipur.",
    meals: "Breakfast"
  },
  {
    day: "Day 04",
    title: "Day Trip to Nathdwara, Eklingji & Haldighati",
    content:
      "After breakfast, head for a day tour to Nathdwara Temple (famous for Lord Krishna), Eklingji Temple (dedicated to Lord Shiva), and the historic battlefield of Haldighati. Return to Udaipur by evening. Overnight stay in Udaipur.",
    meals: "Breakfast"
  },
  {
    day: "Day 05",
    title: "Final Day - Local Sightseeing and Departure",
    content:
      "After checkout, explore the remaining local attractions of Udaipur including Vintage Car Museum, Lake Pichola, Bharatiya Lok Kala Mandal, Karni Mata Ropeway and Temple, Monsoon Palace, and the Biological Park. After the tour, you will be dropped at Udaipur railway station or airport for your onward journey.",
    meals: "Breakfast"
  }
   ],

    ShimlaManali : [
  {
    day: "Day 01",
    title: "Delhi to Shimla (Overnight Journey by Volvo)",
    content:
      "Pickup from Delhi Airport or Railway Station. Proceed to 'Himachal Bhavan Delhi' near Mandi House Metro Station by 08:00 PM. Board the Volvo for an overnight journey to Shimla. Reach Shimla the next morning.",
    meals: "Breakfast"
  },
  {
    day: "Day 02",
    title: "Shimla Local Sightseeing",
    content:
      "On arrival in Shimla, check in to the hotel. After breakfast and freshening up, enjoy local sightseeing including Vice Regal Lodge (now Indian Institute of Advanced Study), Christ Church, Gaiety Theatre, Scandal Point, and Sankat Mochan Temple. Evening free to explore The Mall. Overnight stay in Shimla.",
    meals: "Breakfast"
  },
  {
    day: "Day 03",
    title: "Shimla to Kufri Excursion",
    content:
      "After breakfast, drive to Kufri and visit the Himalayan National Park known for local wildlife. Optional activities include horse and yak rides. Visit Jakhoo Temple located at an altitude of 2,500 meters. Return to Shimla by evening. Overnight stay in Shimla.",
    meals: "Breakfast"
  },
  {
    day: "Day 04",
    title: "Shimla to Manali",
    content:
      "After breakfast, check out from the hotel and drive to Manali. On arrival, check in to your hotel. Rest of the day is free for leisure. Overnight stay in Manali.",
    meals: "Breakfast"
  },
  {
    day: "Day 05",
    title: "Rohtang Pass / Solang Valley Excursion",
    content:
      "After breakfast, excursion to Rohtang Pass (or up to snow line if closed). Enjoy snow activities like skiing, horse/yak rides, and snow scooters (at your own expense). Visit scenic spots like Gulaba, Kothi, Marhi, and Rallha Falls en route. Return to Manali in the afternoon. Overnight stay in Manali.",
    meals: "Breakfast"
  },
  {
    day: "Day 06",
    title: "Kullu and Manikaran Excursion",
    content:
      "After breakfast, excursion to Kullu and Manikaran. Enjoy river rafting (own cost) and visit shawl factories in Kullu. Then proceed to Manikaran to visit hot sulphur springs, Ram Temple, and Gurudwara. Located in Parvati Valley along the river Beas. Return to Manali. Overnight stay in Manali.",
    meals: "Breakfast"
  },
  {
    day: "Day 07",
    title: "Manali Local Sightseeing & Return to Delhi",
    content:
      "After breakfast, visit local attractions in Manali like Hadimba Devi Temple, Tibetan Monastery, Vashisht Village (hot springs), and Club House. By 4:00 PM, proceed to Volvo station for return journey to Delhi by overnight Volvo.",
    meals: "Breakfast"
  }
   ]
};
export default itineraries;